import { FaSearch } from "react-icons/fa";
import './styles.css';

export default function SearchInput({ value, onChange, placeholder }) {
    return (
        <div className="search-container">
            <FaSearch className="search-icon" />

            <input
                type="text"
                className="search-input"
                placeholder={placeholder}
                value={value}
                onChange={onChange}
            />
        </div>
    )
}